import { useContext } from 'react'
import { GlobalContext } from '../../contexts/Global'
import * as S from './style'
import {
  FacebookIcon,
  InstagramIcon,
  LinkedInIcon,
  TwitterIcon,
  YouTubeIcon,
} from '../../assets/images/icons/SocialIcons'
import Link from '../Link'

const companyName = 'A2A Energia S.p.A. - C.F / P.I. 12883420155'
const socialLinks = [
  {
    name: 'twitter',
    url: 'https://twitter.com/gruppo_a2a?lang=it',
    icon: <TwitterIcon />,
  },
  {
    name: 'linkedin',
    url: 'https://www.linkedin.com/company/a2a',
    icon: <LinkedInIcon />,
  },
  {
    name: 'facebook',
    url: 'https://it-it.facebook.com/A2AEnergia/',
    icon: <FacebookIcon />,
  },
  {
    name: 'instagram',
    url: 'https://www.instagram.com/a2alifecompany/?hl=en',
    icon: <InstagramIcon />,
  },
  {
    name: 'youtube',
    url: 'https://www.youtube.com/user/a2a',
    icon: <YouTubeIcon />,
  },
]
const links = [
  {
    label: 'Privacy Policy',
    url: `${process.env.REACT_APP_LOGO_URL}/privacy-cookie-policy`,
  },
  {
    label: 'Cookie Policy',
    url: `${process.env.REACT_APP_LOGO_URL}/cookie-policy`,
  },
  {
    label: 'Note legali',
    url: `${process.env.REACT_APP_LOGO_URL}/informazioni-legali`,
  },
  {
    label: 'Informativa privacy',
    url: `${process.env.REACT_APP_LOGO_URL}/informativa-privacy`,
  },
  {
    label: 'Maggior Tutela',
    url: `https://maggiortutela.a2a.it`,
  },
  {
    label: 'Dichiarazione di accessibilità',
    url: `${process.env.REACT_APP_LOGO_URL}/dichiarazione-accessibilita-sito`,
  },
]

const Footer = () => {
  const {
    state: { isAlternativeActive, forgotDetails },
  } = useContext(GlobalContext)
  return (
    <S.FooterContainer style={{ width: '100%' }}>
      <S.FooterSocialLinks>
        {socialLinks.map((link, i) => (
          <li key={i}>
            <Link to={link.url} target="_blank" rel="noopener">
              {link.icon}
            </Link>
          </li>
        ))}
      </S.FooterSocialLinks>
      <S.FooterLinksWrapper>
        <S.FooterCompanyName>{companyName}</S.FooterCompanyName>
        <S.FooterCompanyLinks>
          {links.map((link, i) => (
            <li key={i}>
              <Link target={'_blank'} to={link.url}>
                {link.label}
              </Link>
            </li>
          ))}
          <li>
            <a
              style={{ cursor: 'pointer' }}
              onClick={(e) => {
                e.preventDefault()
                if (window?._iub?.cs.api.openPreferences) {
                  window._iub.cs.api.openPreferences()
                }
              }}
            >
              Preferenze cookie
            </a>
          </li>
        </S.FooterCompanyLinks>
      </S.FooterLinksWrapper>
    </S.FooterContainer>
  )
}

export default Footer
